import fetcher_v2 from "../fetcher_v2";
import { URLS } from "../urls";

type Timezone = string;

export const getTimezones = async () => {
  return fetcher_v2<Timezone[]>(URLS.TIMEZONES);
};
